import PageHero from "../../components/PageHero/PageHero";
import servicesHeroImage from "../../assests/images/Services-Hero.jpg";
import ServicesSection from "../../components/ServicesSection/ServicesSection";
import IssuesWeFix from "../../components/IssuesWeFix/IssuesWeFix";
import SupportedBrands from "../../components/SupportedBrands/SupportedBrands";
import HowItWorks from "../../components/HowItWorks/HowItWorks";
import CTA from "../../components/CTA/CTA";

function Services() {
  return (
    <>
      <PageHero
        badge="Professional Mobile Repair Services"
        title="Hardware & Software Repair Solutions For All Mobile Devices"
        description="From cracked screens and battery replacements to motherboard repairs and software troubleshooting, we provide complete repair solutions for iPhone, Samsung, Xiaomi, Oppo, Huawei, Vivo, and all major smartphone brands."
        backgroundImage={servicesHeroImage}
      />

      <ServicesSection
        badge="Repair Categories"
        title="Hardware & Software Repair Services"
        description="Professional repair solutions for all major smartphone brands and devices."
      />

      <IssuesWeFix />

      <SupportedBrands />
      <HowItWorks />
      <CTA />
    </>
  );
}

export default Services;
